// extracted by mini-css-extract-plugin
export default {"product-tasks-table":"ProductTasksTable_product-tasks-table__nOLYu","comment-expansion-container":"ProductTasksTable_comment-expansion-container__UjQ6E"};